const getters = {
  token: (state) => state.user.token,
  permissions: (state) => state.user.permissions,
  userData: (state) => state.user.userData,
  mainBodyType: (state) => state.user.mainBodyType,
};
export default getters;
